// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__t4gyW","home_title":"preset_apps_home_title__MhI1t","foot":"preset_apps_foot__6h6iJ"};